<template>
    <div>
        <validation-observer
                ref="observer"
        >
            <v-form ref="form" v-model="formValid" lazy-validation>
                <validation-provider
                        v-slot="{ errors }"
                        name="Name"
                        rules="required"
                >
                    <v-text-field
                            v-model="value.name"
                            label="Name *"
                            :error-messages="errors"
                    />
                </validation-provider>
                <validation-provider
                        v-slot="{ errors }"
                        name="Value"
                        rules="required"
                >
                    <v-text-field
                            v-model="value.value"
                            label="Value *"
                            :error-messages="errors"
                    />
                </validation-provider>
            </v-form>
        </validation-observer>
    </div>
</template>

<script>

    import {required} from 'vee-validate/dist/rules'
    import {extend, ValidationObserver, ValidationProvider, setInteractionMode} from 'vee-validate'

    setInteractionMode('eager')

    extend('required', {
        ...required,
        message: '{_field_} can not be empty',
    })

    export default {
        components: {
            ValidationProvider,
            ValidationObserver,
        },
        props: {
            value: {
                type: Object,
            },
        },
        data() {
            return {
                formValid: null,
            }
        },
        methods: {
            validate() {
                return this.$refs.observer.validate()
            },
        },
    }
</script>

<style scoped>

</style>